import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { INTAKE_QUESTIONNAIRES_API_BASE } from '../../constants';

import type {
  CreateIntakeReferralPayload,
  DeleteIntakeReferralPayload,
  IIntakeReferral,
  UpdateIntakeReferralPayload,
} from './types';

export function createIntakeReferralThunks() {
  return {
    createIntakeReferral: createIntakeReferral(),
    updateIntakeReferral: updateIntakeReferral(),
    deleteIntakeReferral: deleteIntakeReferral(),
  };
}

function createIntakeReferral() {
  return createAsyncThunk<IIntakeReferral, CreateIntakeReferralPayload>(
    'intakeQuestionnaire/createIntakeReferral',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/referral`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function updateIntakeReferral() {
  return createAsyncThunk<IIntakeReferral, UpdateIntakeReferralPayload>(
    'intakeQuestionnaire/updateIntakeReferral',
    async ({ intakeQuestionnaireId, referralId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/referral/${referralId}`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteIntakeReferral() {
  return createAsyncThunk<void, DeleteIntakeReferralPayload>(
    'intakeQuestionnaire/deleteIntakeReferral',
    async ({ intakeQuestionnaireId, referralId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/referral/${referralId}`,
        getAccessTokenSilently,
      });
    },
  );
}
